import { useGetRequisitionItemQuery } from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';
import { useAppSelector } from '@Hooks/index';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import MaterialTabItem from './MaterialTabItem';

interface ViewModalContentProps {}

const ViewModalContent: React.FC<ViewModalContentProps> = () => {
  const reqId = useAppSelector(getModalRecordKey);
  const { data } = useGetRequisitionItemQuery(reqId);

  if (!data) {
    return null;
  }

  const {
    reqItemId,
    actCode,
    resCode,
    matCode,
    ledgerCode,
    plantCode,
    unitName,
    reqQty,
    transferRemarks,
    repeatForAll,
  } = data;

  return (
    <MaterialTabItem
      key={reqItemId}
      index={reqItemId}
      activityCode={actCode}
      resourceCode={resCode}
      materialCode={matCode}
      ledgerCode={ledgerCode}
      plantCode={plantCode}
      unit={unitName}
      qty={reqQty}
      remarks={transferRemarks}
      repeatItem={repeatForAll}
    />
  );
};

export default ViewModalContent;
